module.exports = __webpack_public_path__ + "static/media/Icons-9.a7632693.svg";